import style from './Preview_mobile.module.css';
import React, { useEffect, useState, Component } from 'react';
import Slider from 'react-slick';
import { badges, dummyImages } from '../../../constant/contants';
import BackIcon from '../../../Assets/BackIcon.svg';
import studentProfile from '../../../Assets/studentProfile.svg';
import edit3 from '../../../Assets/edit3.svg';
import delete1 from '../../../Assets/delete1.svg';
import Swal from 'sweetalert2';

import location from '../../../Assets/location.svg';
import image3 from '../../../Assets/image3.svg';
import { useNavigate, useParams } from 'react-router-dom';
import { deleteWork, getSingleStudentWork, getUserById } from 'services/api';
import { CheckMediaType } from 'helper/helper';
import { AddEmbededVideo } from 'helper/helper';
import { useSelector } from 'react-redux';
import more1 from '../../../Assets/more1.svg';
import { Box } from '@chakra-ui/react';

export const Preview_mobile = () => {
  const { id, studentId } = useParams();
  const [studentData, setStudentData] = useState({});
  const [studentUploadedWork, setStudentUploadedWork] = useState([]);
  const [user, setUser] = useState({});
  const [openmodel, setOpenmodel] = useState(false);

  const student = useSelector((state) => state.student);
  // console.log('data', student);

  const recruiter = useSelector((state) => state);
  // console.log('recruiter', recruiter);

  const handleOpenmodel = () => {
    setOpenmodel(!openmodel);
  };
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const tools = [
    'Unreal',
    'Unity',
    'Adobe Lightroom',
    'Unreal',
    'Unity',
    'Adobe Lightroom',
  ];

  useEffect(() => {
    if (id) {
      const fetchUser = async () => {
        const { data } = await getSingleStudentWork(id, studentId);

        // console.log(data)
        setStudentData(data?.data[0]);
        setUser(data?.userDetails);
      };
      fetchUser();
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const fetchUser = async () => {
        const { data } = await getUserById(id);
        setUser(data?.data);
      };
      fetchUser();
    }
  }, [id]);

  const navigate = useNavigate();

  // delete

  const deleteUploadWork = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await deleteWork(id);
          const filterData = studentUploadedWork?.filter(
            (item) => item._id !== id
          );
          setStudentUploadedWork(filterData);
          Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
          navigate(-1, { replace: true });
        } catch (e) {
          console.log(e);
        }
      }
    });
  };

  return (
    <div className={style.container}>
      <div
        className={style.Back}
        onClick={() => navigate(-1, { replace: true })}
      >
        <img src={BackIcon} alt='BackIcon' />
        Back
      </div>
      <div>
        <div className={style.nametext}>{studentData?.title}</div>
        {/* <div className={style.text}>&nbsp;{studentData?.tags}</div> */}
      </div>

      <div
        className={style.ProfileCont}
        style={{
          display: 'flex',
          justifyContent: studentId ? 'flex-start' : 'space-evenly',
        }}
      >
        <div className={style.Profile}>
          <img
            src={student?.profilePhoto || user?.profilePhoto}
            alt='studentProfile'
            onError={(e) => (e.target.src = studentProfile)}
          />
        </div>
        <div className={style.detailsContainer}>
          <div className={style.student_name}>
            {student?.name || user?.name}
          </div>
          <div className={style.levelLocation}>
            <div className={style.level}>
              {student?.jobTitle || user?.jobTitle}
            </div>
            <div className={style.line}></div>
            <img src={location} alt='location' className={style.locationImg} />
            <div className={style.location}>
              {student?.location || user?.location}
            </div>
          </div>
        </div>
        <div
          style={{
            display: studentId ? 'none' : 'flex',
            justifyContent: studentId ? 'flex-start' : 'space-between',
          }}
        >
          <img src={more1} alt='' onClick={handleOpenmodel} />
          {openmodel ? (
            <div className={style.openmodel}>
              <div
                className={style.closemodel}
                onClick={() => navigate(`/hiring/student/editwork/${id}`)}
              >
                <img src={edit3} alt='' />
                <div>Edit</div>
              </div>
              <div
                className={style.closemodel}
                onClick={(_id) => deleteUploadWork(_id)}
              >
                <img src={delete1} alt='' />
                <a>Delete</a>
              </div>
            </div>
          ) : null}
        </div>
      </div>
      <div className={style.imagesContainer}>
        <Slider {...settings}>
          {studentData?.url
            ?.filter((item) => !item?.includes('__blank'))
            ?.map((v) => (
              <>
                <div className={style.Priview_images}>
                  {CheckMediaType(v) === 'image' && <img src={v} alt='' />}
                  {CheckMediaType(v) === 'video' && (
                    <video src={v} alt='' controls />
                  )}
                </div>
                {CheckMediaType(v) === 'other' && (
                  <iframe
                    src={AddEmbededVideo(v)}
                    alt=''
                    height={500}
                    width={'100%'}
                  />
                )}
              </>
            ))}
        </Slider>
      </div>
      {/* about */}
      <div className={style.AboutCont}>
        <p>About Project</p>
        {studentData?.about?.length > 0 ? (
          <Box
            height={'150px'}
            textAlign={'left'}
            overflowY={'scroll'}
            css={{
              '&::-webkit-scrollbar': {
                width: '6px',
              },
              '&::-webkit-scrollbar-track': {
                width: '5px',
              },
              '&::-webkit-scrollbar-thumb': {
                borderRadius: '5px',
                background: 'lightgrey',
              },
            }}
            className={style.About}
          >
            {studentData?.about}
          </Box>
        ) : (
          <>-</>
        )}
      </div>
      {/* tools used */}
      <div className={style.ToolsCont}>
        <p>Tools used</p>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            marginTop: '12px',
            marginLeft: '-24px',
          }}
        >
          {studentData?.tools?.length > 0 ? (
            <div className={style.ToolsIcon}>
              {studentData?.tools?.split(',').map((i) => (
                <div className={style.text}>{i}</div>
              ))}
            </div>
          ) : (
            <>-</>
          )}
        </div>
      </div>
      {/* tags */}
      <div className={style.ToolsCont}>
        <p>Tags</p>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '8px',
            marginTop: '12px',
            marginLeft: '-24px',
          }}
        >
          {studentData?.tags?.length > 0 ? (
            <div className={style.ToolsIcon}>
              {/* <div className={style.text1}>&nbsp;{studentData?.tags}</div> */}
              {studentData?.tags?.split(',').map((i) => (
                <div className={style.text}>{i}</div>
              ))}
            </div>
          ) : (
            <>-</>
          )}
        </div>
      </div>
    </div>
  );
};
